import React, { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import Layout from "../../../layout";
import SubMenu from "../../../components/SubMenu";
import Card from "../../../components/Card";
import BackButton from "../../../components/BackButton";
import { useTourGuide } from "../../../hooks/useTourGuide";

// Sub-components
import MyJobs from "../MyJobs";
import AddNewPost from "../../../layout/NewPost";
import RequestHiringSupport from "../../../layout/RequestHiringSupport";

import "./index.scss";

const MyJobPosts = () => {
  useTourGuide();
  const { pathname } = useLocation();
  const history = useHistory();

  // State for duplication, lifted from MyJobs to pass to Layout
  const [newPost, setNewPost] = useState(false);
  const [duplicatedData, setDuplicatedData] = useState(null);
  const [postJobActive, setPostJobActive] = useState(false);

  React.useEffect(() => {
    const handleModalState = (e) => setPostJobActive(e.detail.isOpen);
    window.addEventListener("post-job-modal-state", handleModalState);
    return () => window.removeEventListener("post-job-modal-state", handleModalState);
  }, []);

  const subMenuOptions = [
    ["Jobs Posted", "/my-job-posts/jobs-posted", undefined, postJobActive ? false : undefined],
    ["Post a Job", () => window.dispatchEvent(new Event("open-template-selector")), undefined, postJobActive],
    ["Request Hiring Support", "/my-job-posts/hiring-support", undefined, postJobActive ? false : undefined],
  ];

  const handleDuplicate = (duplicatePayload) => {
    setDuplicatedData(duplicatePayload);
    setNewPost(true);
  };

  const handleDuplicateClose = () => {
    setNewPost(false);
    setDuplicatedData(null);
  };

  const displaySection = () => {
    if (pathname.includes("hiring-support")) {
      return (
        <Card>
          <RequestHiringSupport
            inline={true}
            open={true}
            onClose={() => {}}
          />
        </Card>
      );
    } else {
      // Default: Jobs Posted
      return (
        <MyJobs
          noLayout={true}
          onDuplicate={handleDuplicate}
        />
      );
    }
  };

  return (
    <Layout
      isOnDuplicatePost={newPost}
      duplicatedDataValue={duplicatedData}
      onDuplicateClose={handleDuplicateClose}
    >
      <div className="insights d-flex flex-column flex-md-row mt-3">
        <div className="sub-menu-container">
          <BackButton />
          <SubMenu menuOptions={subMenuOptions} includeSVG />
        </div>
        <div className="main-content pt-2 pt-md-0 ml-md-4">
          {displaySection()}
        </div>
      </div>
    </Layout>
  );
};

export default MyJobPosts;
